module.exports = __webpack_public_path__ + "img/logo_natura2000.3af51161.jpg";